import { Box, Card, LoadingMask } from '@zillow/constellation-10';
import type { ComponentProps } from 'react';
import { useVisibility } from '../../hooks/useVisibility';

const PLACEHOLDER_HEIGHT = '500px';

export const GraphCard = ({
  children,
  css,
  loading = false,
  error,
  ...props
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}: ComponentProps<typeof Card> & { loading?: boolean; error?: any }) => {
  const { ref, isVisible } = useVisibility({ rootMargin: '200px' });

  return (
    <Box ref={ref} css={{ width: '100%', minHeight: isVisible ? undefined : PLACEHOLDER_HEIGHT }}>
      {isVisible ? (
        <LoadingMask iconSize="lg" loading={loading} css={{ width: '100%', '& > div': { width: '100%' } }}>
          <Card elevated={false} css={{ padding: '600', paddingBottom: '1200', width: '100%', ...css }} {...props}>
            {children}
          </Card>
        </LoadingMask>
      ) : null}
    </Box>
  );
};
